import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { Dm_LoaiPhieu_Model } from '../loai-phieu-model/loai-phieu.model';
const API_ROOT_URL = environment.ApiRoot + '/loaiphieu';
@Injectable()
export class LoaiPhieuService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
			const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
			return this.http.get<any>(API_ROOT_URL + '/DM_LoaiPhieu_List', { 
				headers: httpHeaders,
				params: httpParams
			});
	}
	deleteLoaiPhieu(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DM_LoaiPhieu_Delete?Id=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	createLoaiPhieu(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<Dm_LoaiPhieu_Model>(API_ROOT_URL+'/DM_LoaiPhieu_Insert', item, { headers: httpHeaders });
	}
	updateLoaiPhieu(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<Dm_LoaiPhieu_Model>(API_ROOT_URL+'/DM_LoaiPhieu_Update', item, { headers: httpHeaders });
	}
	getDataThuocPhieu(): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
			return this.http.get<any>(API_ROOT_URL + '/DM_LoaiPhieu_ListParent', { 
				headers: httpHeaders,
			});
	}
	getDataPhieuIn(Id:number): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
			return this.http.get<any>(API_ROOT_URL + `/DM_LoaiPhieu_ListPhieuIn?Id=${Id}`, { 
				headers: httpHeaders,
			});
	}

	getTicketTypesByForm(source: string): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("source", source);
		return this.http.get<any>(`${API_ROOT_URL}/get_ticket_type_by_form`, {
			headers: httpHeaders, 
			params: httpParams 
		});
	}
}
